var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTesttube = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8887 6.1416L17.8583 11.1113L8.74728 20.2223C7.37494 21.5947 5.14995 21.5947 3.77761 20.2223V20.2223C2.40528 18.85 2.40527 16.625 3.77761 15.2527L12.8887 6.1416Z",
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.03 3.65656C17.9449 2.74167 19.4282 2.74167 20.3431 3.65656V3.65656C21.258 4.57145 21.258 6.05478 20.3431 6.96967L19.5148 7.79795L16.2017 4.48483L17.03 3.65656Z",
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4744 3.24242C13.1605 2.55625 14.273 2.55625 14.9592 3.24242L20.7572 9.04036C21.4433 9.72653 21.4433 10.839 20.7572 11.5252V11.5252C20.071 12.2114 18.9585 12.2114 18.2723 11.5252L12.4744 5.72725C11.7882 5.04108 11.7882 3.92859 12.4744 3.24242V3.24242Z",
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L15 14",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTesttube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/testtube.3d04c113d05ca27856c602e7707e0a2b.svg";